import React from 'react'
import ClientSuspense from '@components/ClientSuspense'
import {getMyOrderPreferences_preferences} from '@data/queries/preferences/__generated__/getMyOrderPreferences'
import {getWebsiteMenuInformation_cached_website} from '@data/queries/website/__generated__/getWebsiteMenuInformation_cached'
import {useEffect} from '@hooks/useEffect'
import useIsStore from '@hooks/useIsStore'
import useUrlSearch from '@hooks/useUrlSearch'
import useURLState from '@hooks/useURLState'
import {useRouter} from 'next/router'

import useLayout from '../useLayout'

import Categories from './Categories'
import Loading from './Loading'
import Product from './Product'
import Search from './Search'
import SearchResults from './SearchResults'

import styles from './styles.module.css'

export interface CategoriesLayoutProps {
  website: getWebsiteMenuInformation_cached_website
  menuId: string
  storeId: string
  deliverAt: any
  preferences: getMyOrderPreferences_preferences
  productCardDesign: string
}

export default function CategoriesLayout(props: CategoriesLayoutProps) {
  const {menuId, storeId, deliverAt, preferences, productCardDesign, website} = props
  const router = useRouter()

  const [categoryId, setCategoryId] = useURLState('cat')
  const layout = useLayout(website)
  const isStore = useIsStore()
  const {productId} = router.query
  const showCategories = layout === 'mobile' && isStore
  const {filter, filterText, setFilter} = useUrlSearch()

  const handleChangeCategory = updateCategoryId => {
    if (isStore) {
      router.push(`/pedir/category/${updateCategoryId}`)
    } else {
      setCategoryId(updateCategoryId)
    }
  }

  useEffect(() => {
    if (filter && categoryId) {
      setCategoryId(null)
    }
  }, [filter])

  return (
    <div className={styles.container}>
      <div className={styles.searchBar}>
        <Search filter={filterText} setFilter={setFilter} showCategories={showCategories} />
      </div>
      <ClientSuspense fallback={<Loading />}>
        {filter ? (
          <SearchResults
            filter={filter}
            setFilter={setFilter}
            storeId={storeId}
            deliverAt={deliverAt}
            menuId={menuId}
          />
        ) : (
          <Categories
            categoryId={categoryId}
            setCategoryId={handleChangeCategory}
            storeId={storeId}
            deliverAt={deliverAt}
            menuId={menuId}
            hideNotAvailableProducts={website.hideNotAvailableProducts}
          />
        )}
      </ClientSuspense>
      {productId ? (
        <Product
          productId={productId}
          storeId={storeId}
          deliverAt={deliverAt}
          menuId={menuId}
          preferences={preferences}
          productCardDesign={productCardDesign}
        />
      ) : null}
    </div>
  )
}
